// extracted by mini-css-extract-plugin
export default {"container":"NotesQuoteForm_container__4sgMP","label":"NotesQuoteForm_label__GrAkD"};